<template>
    <div class="page-breadcrumbs">
        <page-breadcrumbs :list="breadcrumbs" />
    </div>
    <h2 class="page-title">
        Edit Questions and Answers
    </h2>
    <el-row :gutter="20">
        <el-col>
            <question-form
                v-loading="loading"
                :initial-form="formData"
                @saved="goToEdit"
                @cancel="$router.push({name: 'lessons.edit', params: {lm_id: $route.params.lm_id, chapter_id: $route.params.chapter_id, lesson_id: $route.params.lesson_id}})"
            />
        </el-col>
    </el-row>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import questionForm from './QuestionForm'
import {useRoute, useRouter} from 'vue-router'
import PageBreadcrumbs from '~/base/components/page-breadcrumbs/PageBreadcrumbs'
import questionApi from "~/modules/learning_module/questionApi";
import store from "~/store";
import { LEARNING_SS } from "~/store/mutation-types";

const route = useRoute()
const router = useRouter()
const formData = ref(null)
const learningTabValue = computed(() => store.getters['learnings/learningTabValue'])
const loading = ref(false)
const breadcrumbs = ref([
    {
        title: '..',
        path: '/'
    },
    {
        title: learningTabValue.value === LEARNING_SS ? 'Learning modules' : 'Coach modules',
        name: 'learning_modules.index'
    },
    {
        title: 'Chapters',
        name: 'learning_modules.edit',
        params: {lm_id: route.params.lm_id},
    },
    {
        title: 'Lessons',
        name: 'chapters.edit',
        params: {lm_id: route.params.lm_id, chapter_id: route.params.chapter_id},
    },
    {
        title: 'Questions',
        name: 'lessons.edit',
        params: {lm_id: route.params.lm_id, chapter_id: route.params.chapter_id, lesson_id: route.params.lesson_id},
    },
    {
        title: 'Edit question',
    }
])

onMounted(() => fetchData())

async function fetchData() {
    loading.value = true
    const {data} = await questionApi.get(route.params.question_id)
    formData.value = data.data
    formData.value.id = data.data._id
    if (formData.value.id && formData.value.type === 'boolean') {
        formData.value.answer = `${formData.value.answers.some(item => item.answer === 'true' && item.correct === true)}`
    }
    loading.value = false
}

function goToEdit() {
    router.push({name: 'lessons.edit', params: {lm_id: route.params.lm_id, chapter_id: route.params.chapter_id, lesson_id: route.params.lesson_id}})
}
</script>
